/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The DashboardCompanySummaryComponentSupplyHistory model module.
* @module model/DashboardCompanySummaryComponentSupplyHistory
* @version 2020-12-7
*/
export default class DashboardCompanySummaryComponentSupplyHistory {
    /**
    * Constructs a new <code>DashboardCompanySummaryComponentSupplyHistory</code>.
    * @alias module:model/DashboardCompanySummaryComponentSupplyHistory
    * @class
    * @param _date {Number} 
    * @param count {Number} 
    * @param amount {Number} 
    */

    constructor(_date, count, amount) {
        
        
        this['date'] = _date;
        this['count'] = count;
        this['amount'] = amount;
        
    }

    /**
    * Constructs a <code>DashboardCompanySummaryComponentSupplyHistory</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardCompanySummaryComponentSupplyHistory} obj Optional instance to populate.
    * @return {module:model/DashboardCompanySummaryComponentSupplyHistory} The populated <code>DashboardCompanySummaryComponentSupplyHistory</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardCompanySummaryComponentSupplyHistory();
                        
            
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Number');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} date
    */
    'date' = undefined;
    /**
    * @member {Number} count
    */
    'count' = undefined;
    /**
    * @member {Number} amount
    */
    'amount' = undefined;




}
